import React, { useEffect, useState } from 'react';
import {
    Alert,
    Box,
    Button,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { IconPlus, IconWorld } from '@tabler/icons';
import api from '../../../../services/api';
import PageHeader from '../../../../../ui-component/extended/PageHeader';
import GlassCard from '../../../../../ui-component/extended/GlassCard';

const Countries = () => {
    const history = useHistory();
    const [appId, setAppId] = useState(null);
    const [countries, setCountries] = useState([]);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [form, setForm] = useState({ code: '', name: '' });

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('v1/apps/default/');
                setAppId(res.data.app.id);
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);

    useEffect(() => {
        if (!appId) return;
        loadCountries();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId]);

    const loadCountries = async () => {
        try {
            const res = await api.get(`v1/apps/${appId}/countries/`);
            setCountries(res.data || []);
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao carregar países' });
        }
    };

    const handleSave = async () => {
        try {
            await api.post(`v1/apps/${appId}/countries/`, form);
            setDialogOpen(false);
            setForm({ code: '', name: '' });
            loadCountries();
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao criar país' });
        }
    };

    return (
        <Box>
            <PageHeader
                icon={IconWorld}
                gradient="blue"
                title="Geografia - Países"
                subtitle="Clique num país para ver seus estados"
                actions={
                    <Button variant="contained" startIcon={<IconPlus size={18} />} onClick={() => setDialogOpen(true)}>
                        Novo país
                    </Button>
                }
            />

            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2 }}>
                    {status.message}
                </Alert>
            )}

            <GlassCard>
                <CardContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Código</TableCell>
                                <TableCell>Nome</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {countries.map((country) => (
                                <TableRow
                                    key={country.id}
                                    hover
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => history.push(`/dashboard/config/references/geography/countries/${country.id}/states`, { country })}
                                >
                                    <TableCell>{country.code}</TableCell>
                                    <TableCell>{country.name}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </GlassCard>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Novo país</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField
                            label="Código (ISO, ex: BR)"
                            fullWidth
                            value={form.code}
                            onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })}
                        />
                        <TextField label="Nome" fullWidth value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleSave}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Countries;
